export default __webpack_public_path__ + "ccb5216bd83382a49772790b65a8a875.png";